import React from "react";
import { FeatureCardsModel } from "../models/FeatureCardsModel";
import { MediaModalItemModel } from "../models/MediaModalModel";
import { MediaType } from "../models/MediaType";
import { Breakpoint } from "../utils/Breakpoints";
import throttle from "lodash/throttle";
import CustomEvent from "custom-event";
import { SetAccessoryPackText } from "../utils/Accessories";
import TagManager from "react-gtm-module";
import { Tooltip } from "react-tooltip";
import ImgLazyLoad from "./ImgLazyLoad";

interface FeatureCardsState {
  page: number;
  breakpoint: string;
}

interface FeatureCardsProps {
  content: any;
  itemClassName?: string;
  hiddenFullTextHtml?: Boolean;
}

class FeatureCards extends React.Component<
  FeatureCardsProps,
  FeatureCardsState
> {
  get perPage(): number {
    switch (this.state.breakpoint) {
      case "xs":
        return 1;

      case "sm":
        return 2;

      case "md":
        return 4;

      default:
        return 4;
    }
  }

  get leftPos(): number {
    return this.state.page * (100 / this.perPage) * -1;
  }

  get totalPages(): number {
    const total = this.props.content.length - this.perPage + 1;

    return total <= 1 ? 1 : total;
  }

  get isFirstPage(): boolean {
    return this.state.page === 0;
  }

  get isLastPage(): boolean {
    return this.state.page === this.totalPages - 1;
  }

  constructor(props: FeatureCardsProps) {
    super(props);

    this.state = {
      page: 0,
      breakpoint: Breakpoint(),
    };

    this.prev = this.prev.bind(this);
    this.next = this.next.bind(this);
    this.selectItem = this.selectItem.bind(this);

    window.addEventListener(
      "resize",
      throttle(() => {
        const breakpoint = Breakpoint();
        if (breakpoint !== this.state.breakpoint) {
          this.setState({ breakpoint, page: 0 });
        }
      }, 300)
    );
  }

  next(): void {
    let page = this.state.page + 1;

    if (page < this.totalPages) {
      this.setState({ page });
    }
  }

  prev(): void {
    let page = this.state.page - 1;
    if (page >= 0) {
      this.setState({ page });
    }
  }

  selectItem(item: FeatureCardsModel, hideHeading): void {
    console.log({ item });

    let media = item.media;
    let mediaType = item.type || MediaType.Image;

    if (!!item.youtubeVideoLink) {
      media = item.youtubeVideoLink;
      mediaType = MediaType.YouTube;
    }

    const selectedItem: MediaModalItemModel = {
      media: media,
      type: mediaType,
      title: item.title,
      text: item.textFull,
      slides: item.slides || null,
      hideHeading: hideHeading,
    };

    const evt = new CustomEvent("showMediaModal", {
      detail: { content: [selectedItem] },
    });
    window.dispatchEvent(evt);

    TagManager.dataLayer({
      dataLayer: {
        event: "articleClick",
        title: selectedItem.title,
      },
    });
  }

  render() {
    let { content, itemClassName, hiddenFullTextHtml } = this.props;
    content = content.map((item) =>
      item.isPack ? SetAccessoryPackText(item) : item
    );
    return (
      <div className="featureCards__wrap">
        <Tooltip
          className="tt__componentContent"
          variant="light"
          anchorSelect=".tt"
        />
        <div className="featureCards__itemsWrap">
          <ul
            className={`featureCards__items ${
              this.totalPages === 1 ? "featureCards__items--centered" : ""
            }`}
            style={{ transform: `translateX(${this.leftPos}%)` }}
          >
            {content.map((cardContent: FeatureCardsModel, i: number): any => {
              return (
                <li
                  key={`card__${i}`}
                  className={`featureCards__item ${
                    itemClassName ? itemClassName : ""
                  }`}
                >
                  <div
                    className="featureCards__inner"
                    onClick={(e) => {
                      e.preventDefault();
                      //hiddenFullTextHtml is for articles that's why we are not displaying heading for articles popup.
                      this.selectItem(cardContent, hiddenFullTextHtml);
                    }}
                  >
                    <div className="featureCards__image">
                      <ImgLazyLoad src= {cardContent.thumbnail} />
                    </div>
                    <div className="featureCards__copy">
                      <div>
                        {cardContent.title ? (
                          <h4
                            className="featureCards__title"
                            dangerouslySetInnerHTML={{
                              __html: cardContent.title,
                            }}
                          />
                        ) : null}
                        {cardContent.title &&
                        cardContent.featureCardDisclaimer ? (
                          <span
                            className="tt tt--toRight"
                            data-tooltip-content={cardContent.featureCardDisclaimer}
                          >
                            *
                          </span>
                        ) : null}
                      </div>
                      {cardContent.text ? (
                        <div
                          className="featureCards__text"
                          dangerouslySetInnerHTML={{ __html: cardContent.text }}
                        />
                      ) : null}
                    </div>
                    {hiddenFullTextHtml != null &&
                    hiddenFullTextHtml == true ? (
                      <div
                        className="featureCards__itemHidenContent"
                        dangerouslySetInnerHTML={{
                          __html: cardContent.textFull,
                        }}
                      />
                    ) : null}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <nav className="featureCards__navControls">
          {!this.isFirstPage ? (
            <div
              className="featureCards__navControl featureCards__navControl--prev"
              onClick={(e) => {
                e.preventDefault();
                this.prev();
              }}
            />
          ) : null}
          {!this.isLastPage ? (
            <div
              className="featureCards__navControl featureCards__navControl--next"
              onClick={(e) => {
                e.preventDefault();
                this.next();
              }}
            />
          ) : null}
        </nav>
      </div>
    );
  }
}

export default FeatureCards;
